// extracted by mini-css-extract-plugin
export default {"presentItem":"styles_presentItem__WULZs","text":"styles_text__V17IL","notPresentItem":"styles_notPresentItem__liAZI"};